import RealTransactionStatusSocket from "./RealTransactionStatusSocket";
import MockTransactionStatusSocket from "./MockTransactionStatusSocket";

function getTransactionSocket() {
  return import.meta.env.VITE_CYPRESS_TESTS === "true"
    ? new MockTransactionStatusSocket()
    : new RealTransactionStatusSocket();
}

export default getTransactionSocket;
